import { Box, BoxProps } from '@chakra-ui/react';
import { buttonWithActiveStateSx } from './styles';

export interface ButtonWithActiveStateProps extends BoxProps {
  isActive: boolean;
  onClick?: () => void;
}

export const ButtonWithActiveState = ({
  isActive,
  onClick,
  children,
  ...rest
}: ButtonWithActiveStateProps) => {
  const styles = buttonWithActiveStateSx(isActive);

  return (
    <Box
      sx={styles.root}
      role="button"
      onClick={(e) => {
        e.stopPropagation();
        onClick?.();
      }}
      {...rest}
    >
      {children}
    </Box>
  );
};
